export default __webpack_public_path__ + "static/1454-76a07487da81db5e9e48dff9976ed9b9.gif";